import initial from "./group-10-copy-3.svg";
import withIntersect from "./group-10-copy-4.svg";
import result from "./group-10-copy-5.svg";
import withGeometry from "./group-10-copy-6.svg";

export const images = {
  initial,
  withGeometry,
  withIntersect,
  result,
};
